import { Flag } from '@everlane/icon'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'
import ExpandableContent from 'base/react/components/expandable_content'
import { connect } from 'react-redux'
import Hub from 'base/hub'
import Event from 'base/event'
import { getLocalization, getCountryName } from 'base/lib/localization'
import { changeGeolocation, fetchRegions, fetchMenus } from '../../actions/asynchronous'
import CurrentCountryDisplay from './current_country_display'

export class CountrySelection extends Component {
  static propTypes = {
    fetchRegions: PropTypes.func.isRequired,
    changeGeolocation: PropTypes.func.isRequired,
    closeCountrySelectTray: PropTypes.func.isRequired,
    forMobile: PropTypes.bool,
    regions: PropTypes.array,
    isIntl: PropTypes.bool,
    fetchNavExperiment: PropTypes.func,
  }

  componentDidMount() {
    this.props.fetchRegions()
  }

  trackCountrySelection({ countryCode }) {
    Hub.pub(Event.Header.COUNTRY_TRAY_SELECTION, {
      countryCode: countryCode,
    })
  }

  selectCountry(countryCode) {
    this.props.changeGeolocation(countryCode).then(() => {
      this.trackCountrySelection({ countryCode })
      this.props.closeCountrySelectTray()

      const navVersion = this.props.fetchNavExperiment === 'Control' ? 1 : 2
      this.props.fetchMenus(this.props.isIntl, navVersion)
    })
  }

  renderHeader() {
    return (
      <div>
        <div className="country-selection__header">Select your location.</div>
        <div className="country-selection__description">
          Your currently selected location is {getCountryName()} and your order will be billed in{' '}
          {getLocalization().currency}.
        </div>
      </div>
    )
  }

  renderListItem({ country, forMobile }) {
    return (
      <li
        key={country.code}
        onClick={() => this.selectCountry(country.code)}
        className="country-selection__country"
      >
        {forMobile ? (
          <React.Fragment>
            <div>{this.renderCountry({ country, forMobile })}</div>
            {this.renderCurrency({ country, forMobile })}
          </React.Fragment>
        ) : (
          <span>{this.renderCountry({ country, forMobile })}</span>
        )}
      </li>
    )
  }

  renderCountry({ country, forMobile }) {
    return (
      <div className="country-selection__country-container">
        <Flag className="country-selection__flag" countryCode={country.code} />
        <span className="country-selection__country-info">
          {country.display_name}
          {!forMobile && this.renderCurrency({ country, forMobile })}
        </span>
      </div>
    )
  }

  renderCurrency({ country, forMobile }) {
    if (country.currency) {
      const displayCurrency = forMobile ? country.currency.code : `(${country.currency.code})`
      return <span className="country-selection__country-info">{displayCurrency}</span>
    }
  }

  sortByDisplayName(countries) {
    return countries.sort((a, b) => (a.display_name > b.display_name ? 1 : -1))
  }

  renderExpandableRegion(region) {
    const expandableContentClasses = classNames('country-selection__region', {
      'country-selection__region--desktop': !this.props.forMobile,
    })

    return (
      <ExpandableContent
        key={region.id}
        title={region.name}
        className={expandableContentClasses}
        trayType={'CountrySelectTray'}
      >
        <ul className="country-selection__country-group">
          {this.sortByDisplayName(region.countries).map(country => {
            return this.renderListItem({
              country,
              forMobile: this.props.forMobile,
            })
          })}
        </ul>
      </ExpandableContent>
    )
  }

  render() {
    return (
      <React.Fragment>
        <CurrentCountryDisplay />
        {this.renderHeader()}
        {this.props.regions &&
          this.props.regions.map(region => this.renderExpandableRegion(region))}
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    regions: state.regions && state.regions.regions,
    isIntl: state.session.visitor?.localization?.country_code !== 'US',
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchRegions: () => dispatch(fetchRegions()),
    changeGeolocation: countryCode => dispatch(changeGeolocation(countryCode)),
    fetchMenus: (isIntl, version) => dispatch(fetchMenus({ isIntl, version })),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CountrySelection)
